import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledWrapper,
  StyledDate,
  StyledDay,
  StyledNumber,
  StyledGeneralItem
} from './style';

const DigitalAudienceDate = ({ text, dayWeek, numberWeek, onClick }) => (
  <StyledWrapper>
    <StyledDate>
      <StyledDay> {dayWeek} </StyledDay>
      <StyledNumber>{numberWeek}</StyledNumber>
    </StyledDate>
    <StyledGeneralItem
      text={text}
      onClick={onClick}
      id="digitalAudienceDownload"
    />
  </StyledWrapper>
);

DigitalAudienceDate.propTypes = {
  text: PropTypes.string,
  dayWeek: PropTypes.string,
  numberWeek: PropTypes.string
};

export default DigitalAudienceDate;
